export const forceMobile = (): boolean => document.location.host.includes('local') && document.location.href.includes('mobile');

export const isMobile = (): boolean => (typeof window === 'undefined' ? true : (window && window.innerWidth < 768) || forceMobile());

export const isTabletOrMobile = (): boolean =>
    !!navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i) || isMobile();
